import { useEffect } from 'react';

import { LayoutModal } from '@layouts';
import { useAppDispatch } from '@store/';
import { hideModal } from '@store/Modal';
import { createOfficesRequest } from '@store/Users';
import { UIButton, UIInput } from '@ui';
import { Button } from '@utils/utility-property';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { INITIAL_VALUES } from '../../../modules/Users/FormOffices/constant';
import { validationSchema } from '../../../modules/Users/FormOffices/schema';

const WidgetsModalMobileOffices = () => {
  // const [isOpenColor, setIsOpenColor] = useState(false);
  const { loading } = useSelector((state) => state.users);

  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();

  const handlerSubmit = (values) => dispatch(createOfficesRequest(values));

  const form = useFormik({
    enableReinitialize: true,
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema(),
    onSubmit: handlerSubmit,
  });

  useEffect(() => {
    validationSchema();
  }, [i18n.language]);

  return (
    <LayoutModal title={t('USERS.ADD_OFFICE')} className="modal__users">
      <form onSubmit={form.handleSubmit} className="modal__added__items">
        {/* <UIColor
          className="users-color h6 fw700"
          setColor={(color) => form.setFieldValue('color', color)}
          color={form.values.color}
          setIsOpenColor={setIsOpenColor}
          isOpenColor={isOpenColor}
        /> */}
        <div className="modal-users__items">
          <UIInput
            label={t('COMMON.TITLE')}
            name="name"
            placeholder={t('COMMON.TITLE')}
            className="input input__icon"
            classLabel="fw600"
            value={form.values.name}
            onChange={form.handleChange}
            isValid={!(form.errors.name && form.touched.name)}
            validateText={form.errors.name}
          />
          <div className="added-btn">
            <UIButton
              loading={loading}
              className="btn outline__blue"
              type={Button.SUBMIT}
            >
              <span>{t('COMMON.SAVE')}</span>
            </UIButton>
            <UIButton
              handler={() => dispatch(hideModal())}
              className="btn btn__gray"
            >
              {t('COMMON.CANCEL')}
            </UIButton>
          </div>
        </div>
      </form>
    </LayoutModal>
  );
};

export default WidgetsModalMobileOffices;
